const humanize = (text: string): string => text.split("_").join(" ");

export { humanize };
